export default __webpack_public_path__ + "static/media/Vazir-Medium.b1838727.woff2";